<ng-container *ngIf="!microphoneStatus.isLoading">
	<div *ngIf="isAccessPermissionNoteVisible()" class="row permission-note mt-4">
		<div class="col-12 p-3 d-flex">
			<div class="col-1 pl-0 text-center">
				<span class="icon icomoon icomoon-Icon-Alert" role="img">
					<span class="path1" aria-hidden="true"></span>
					<span class="path2" aria-hidden="true"></span>
				</span>
			</div>
			<br />
			<div class="col-11 pr-0 pl-2">
				<p class="mb-0 mt-auto" id="qs-note">
					{{ getPermissionNoteMessage() | translate }}
				</p>
				<button type="button" class="btn btn-link privacy-button pl-0"
					(click)="onPermissionNoteGoToWindowsClick()" id="qs-access-link" attr.aria-label="qs-access-link"
					role="link">
					{{'dashboard.quickSettings.note.accessUrl' | translate}}
				</button>
			</div>
		</div>
	</div>
</ng-container>
